import React from 'react';
import StarterPanel from '../../components/Dashboard/StarterPanel';
import WifiMetricMiniCard from '../Dashboard/WifiMetricMiniCard';
import { numberFormat } from '../../util/araknerdlib';
import { useSales } from '../../DataStore/SalesContext';

const MetricRow = ({ totalVouchers, totalAmount, avgPrice, currency, velocity }) => (
  <div className="d-flex justify-content-end align-items-center py-3 px-4 rounded">
    <WifiMetricMiniCard label="Total Vouchers Sold" value={numberFormat(totalVouchers, 1)} iconColor="text-info" icon='fas fa-ticket-alt'/>
    <div className="border-left mx-3" style={{ height: 30 }} />
    <WifiMetricMiniCard label="Total Amount Sold" value={`${currency} ${numberFormat(totalAmount, 2)}`} iconColor="text-success" icon='fas fa-wallet'/>
    <div className="border-left mx-3" style={{ height: 30 }} />
    <WifiMetricMiniCard label="Avg Voucher Price" value={`${currency} ${numberFormat(avgPrice, 2)}`} iconColor="text-primary" icon='fas fa-balance-scale'/>
    <div className="border-left mx-3" style={{ height: 30 }} />
    <WifiMetricMiniCard label="Avg Sold / Day" value={numberFormat(velocity, 2)} iconColor="text-warning" icon='fas fa-bolt'/>
  </div>
);

const SalesHeroKpis = ({
  summary,
  currency,
}) => {

  return (
    <div className="row">
        <StarterPanel greetingText='Hi'/>
        <div className="col-lg-8 mb-4">
          <MetricRow
            totalVouchers={summary.total_vouchers_sold}
            totalAmount={summary.total_amount_sold}
            avgPrice={summary.avg_voucher_price}
            velocity={summary.avg_sold_rate_per_day}
            currency={currency}
          />
         
        </div>
      </div>
  );
};

export default SalesHeroKpis;
